/**********************************

  worldpantry-inventory.js   (Alter Eco)

  Cookie helpers + self-heal + early paint + polling auto-trigger + live
  product-inventory functions.

  ZIP ACQUISITION: assets/worldpantry-ipzipcode.js (boss's proxy) only.
  The inline IPStack call and exposed access_key are REMOVED.

  CONSOLIDATION: assets/wp_fast_ship.js is RETIRED on Alter Eco. It
  duplicated these cookie helpers (loaded later, so its copies won), ran
  a SECOND IPStack call with the same exposed key, and did a
  window.location.reload() after every lookup. All of that is gone; its
  <script> line is removed from theme.liquid.

  Shipping submit/display logic lives in
  snippets/worldpantry-fast-shipping-logic.liquid, which also exposes
  window.wpFsRestore for the early paint below.

***********************************/

var WP_INV = {
  endpointKey: 'WP_2025_ALTERECO',
  inventoryUrlSingle: 'https://shop.worldpantry.com/productinventories/altereco/productinventory.aspx',
  inventoryUrlBatch:  'https://shop.worldpantry.com/productinventories/altereco/productinventories.aspx',

  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },

  zipInputSelector: '.zip_input',
  formSelector:     'form.js-fs-form',

  // Alter Eco wording preserved.
  outOfStockDisplay: "Usually ships within <br class='mobile-only'>1-2 weeks",
  inStockDisplay:    "In Stock"
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";     // fixed: was "; ; path=/"
}

function getSessionCookie(name) {
  var nameKey = name + "=";
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split("; ");
  var res;
  cArr.forEach(function (val) {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value != null ? value : "") + expires + "; path=/";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal (No Error / legacy non-ISO dates)
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_INV.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_INV.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) deleteCookie(WP_INV.cookies.calcError);
  }
  var receiveBy = getSessionCookie(WP_INV.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_INV.cookies.orderBy);
  if ((receiveBy && isNaN(new Date(receiveBy))) || (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie(WP_INV.cookies.receiveBy);
    deleteCookie(WP_INV.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger with early paint + first-visit poll.

  jQuery loads before this file in theme.liquid, but keep a short wait
  for safety. On ready: (1) call the shared restore immediately if it is
  available (paints any stored result -> no "See How Fast" flash and no
  reload), then (2) if there is no stored result yet, poll for the zip
  cookie (set by the async proxy) and submit the shared form once.
***********************************/
(function wpInvAutoTrigger() {
  var jqWaits = 0;
  function whenReady() {
    if (typeof window.jQuery === 'undefined') {
      if (jqWaits++ < 50) { setTimeout(whenReady, 100); }
      return;
    }
    window.jQuery(function ($) {
      // Early paint from cookies if the shared logic is present.
      if (typeof window.wpFsRestore === 'function') {
        try { window.wpFsRestore(); } catch (e) {}
      }

      // If we already have a stored result, no lookup needed.
      if (getSessionCookie(WP_INV.cookies.fsZip) && getSessionCookie(WP_INV.cookies.receiveBy)) {
        console.log("FastShip data already exists, skipping auto lookup");
        return;
      }

      var attempts = 0;
      function tryAutoLookup() {
        var zip = getCookie(WP_INV.cookies.zip);
        if (isValidZip(zip)) {
          console.log("fast geo zip " + zip);
          $(WP_INV.zipInputSelector).val(zip);
          $(WP_INV.formSelector).first().submit();
          return;
        }
        if (attempts++ < 20) { setTimeout(tryAutoLookup, 200); }
        else { console.log("no valid zipcode after waiting - giving up auto lookup"); }
      }
      tryAutoLookup();
    });
  }
  whenReady();
})();

/**********************************
  Product Inventory functions
***********************************/
function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  jQuery.post(WP_INV.inventoryUrlSingle, {
    zip: zip, key: WP_INV.endpointKey, productid: productId, variantid: variantId
  }).done(function (data) {
    if (data) {
      if (data.Status == "OutOfStock") data.StatusDisplay = WP_INV.outOfStockDisplay;
      setProductInventoryStatus(data);
    }
  });
}

function getProductNumbers() {
  var productNumbers;
  jQuery.ajax({ type: "GET", url: "/cart?view=wp-productnumbers", async: false })
    .done(function (response) { productNumbers = JSON.parse(response); });
  return productNumbers;
}

function getProductInventories(productNumbers) {
  var items = [];
  var productInventories;
  for (var i = 0; i < productNumbers.length; i++) {
    items.push({ productId: productNumbers[i].productNumber, variantId: productNumbers[i].variantNumber });
  }
  if (items) {
    var shippingInfo = { zip: getCookie(WP_INV.cookies.zip), items: items };
    jQuery.ajax({
      type: "POST", url: WP_INV.inventoryUrlBatch,
      data: { key: WP_INV.endpointKey, shippingInfo: JSON.stringify(shippingInfo) },
      async: false
    }).done(function (data) { productInventories = data; });
  }
  return productInventories;
}

function showProductInventoryCartStatusDisplay(productInventories) {
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == "OutOfStock") return true;
    }
  }
  return false;
}

/* Guarded: skips records with a missing ProductId/VariantId instead of
   throwing on .toUpperCase() of undefined (which killed the PDP render). */
function getProductInventory(id, productNumbers, productInventories) {
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id != id) continue;
    var productNumber = productNumbers[n].productNumber;
    var variantNumber = productNumbers[n].variantNumber;
    for (var i = 0; i < productInventories.length; i++) {
      if (
        productInventories[i].ProductId &&
        productInventories[i].VariantId &&
        productInventories[i].ProductId.toUpperCase() === productNumber.toUpperCase() &&
        productInventories[i].VariantId.toUpperCase() === variantNumber.toUpperCase()
      ) {
        var inv = productInventories[i];
        inv.StatusDisplay = (inv.Status === "OutOfStock" || inv.Status === "AlwaysSell")
          ? WP_INV.outOfStockDisplay : WP_INV.inStockDisplay;
        return inv;
      }
    }
    return null;
  }
  return null;
}
